import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filter: {
    voucherTab: "Order Wise",
    selectedFilter: "All",
    keyword: "",
    orderdDaysTab: "today",
  },
  pagination: {
    page: 1,
    pages: 1,
  },
  ui: {
    isSearchBarOpen: false,
  },
};

const productionDetailsSlice = createSlice({
  name: "production",
  initialState,
  reducers: {
    setFilter: (state, action) => {
      state.filter = { ...state.filter, ...action.payload };
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    setUi: (state, action) => {
      state.ui = { ...state.ui, ...action.payload };
    },
  },
});

export const { setFilter, setPagination, setUi } =
  productionDetailsSlice.actions;

export default productionDetailsSlice.reducer;
